/**
 * QA Debugging Helper
 * Intercepts console errors from iframe to capture xAPI State API 404s
 */

// Log environment info on startup
// console.log('═══════════════════════════════════════');
// console.log('[🔐 XAPI-AUTH] 🌍 Environment Information');
// console.log('[🔐 XAPI-AUTH] Origin:', window.location.origin);
// console.log('[🔐 XAPI-AUTH] Hostname:', window.location.hostname);
// console.log('[🔐 XAPI-AUTH] Protocol:', window.location.protocol);
// console.log('[🔐 XAPI-AUTH] User Agent:', navigator.userAgent);
// console.log('[🔐 XAPI-AUTH] Timestamp:', new Date().toISOString());
// console.log('═══════════════════════════════════════');

// Monitor for fetch/XHR errors globally
const originalFetch = window.fetch;
window.fetch = async function(...args): Promise<Response> {
  // Extract URL string from fetch argument (can be string, Request, or URL object)
  const urlString = typeof args[0] === 'string' 
    ? args[0] 
    : args[0] instanceof Request 
      ? args[0].url 
      : String(args[0]);
  
  // Log xAPI-related fetches
  if (urlString.includes('/api/xapi')) {
    // console.log('[🔐 XAPI-AUTH] 🌐 Fetch request:', urlString);
    
    // Log request auth details for xAPI calls
    const options = args[1] as RequestInit | undefined;
    if (options?.credentials === 'include') {
      // console.log('[🔐 XAPI-AUTH] ✅ Using cookie-based auth (credentials: include)');
    } else if (options?.headers) {
      // console.log('[🔐 XAPI-AUTH] 📋 Request headers:', options.headers);
      const headers = options.headers as Record<string, string>;
      if (headers['Authorization']) {
        // console.log('[🔐 XAPI-AUTH] ✅ Authorization header is present');
      } else {
        // console.error('[🔐 XAPI-AUTH] ❌ No Authorization header and no credentials:include!');
      }
    } else {
      // console.error('[🔐 XAPI-AUTH] ❌ No auth method detected!');
    }
  }
  
  try {
    const response = await originalFetch.apply(this, args);
    
    // Log xAPI responses
    if (urlString.includes('/api/xapi')) {
      if (response.ok) {
        // console.log('[🔐 XAPI-AUTH] ✅ Fetch success:', urlString, '| Status:', response.status);
      } else {
        console.error('[🔐 XAPI-AUTH] ❌ Fetch failed:', urlString, '| Status:', response.status);
        console.error('[🔐 XAPI-AUTH] 🔍 Response:', await response.clone().text());
      }
    }
    
    return response;
  } catch (error) {
    console.error('[🔐 XAPI-AUTH] 🚨 Fetch error:', urlString, '| Error:', error);
    throw error;
  }
};

// Store reference for cleanup if needed
(window as any).__xapiAuthDebugActive = true;
// console.log('[🔐 XAPI-AUTH] ✅ Authentication debug monitoring active');
window.addEventListener('unhandledrejection', (event) => {
  console.error('[QA DEBUG] 🚨 Unhandled promise rejection:', event.reason);
});

// Export to make this a module (required by TypeScript isolatedModules)
export {};

// console.log('[QA DEBUG] ✅ Debug monitoring active');
